var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5C3.70435 4.5 2.94129 4.81607 2.37868 5.37868C1.81607 5.94129 1.5 6.70435 1.5 7.5V16.5C1.5 17.2956 1.81607 18.0587 2.37868 18.6213C2.94129 19.1839 3.70435 19.5 4.5 19.5H12.75C13.5456 19.5 14.3087 19.1839 14.8713 18.6213C15.4339 18.0587 15.75 17.2956 15.75 16.5V7.5C15.75 6.70435 15.4339 5.94129 14.8713 5.37868C14.3087 4.81607 13.5456 4.5 12.75 4.5H4.5ZM19.94 18.75L17.25 16.06V7.94L19.94 5.25C20.884 4.305 22.5 4.974 22.5 6.31V17.69C22.5 19.026 20.884 19.695 19.94 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOn);
export default __webpack_public_path__ + "static/media/cam-on.1657639b76475f73e12d4a518070107c.svg";
export { ForwardRef as ReactComponent };